<template>
    <div id="step-type" class="step" :class="this.$parent.edit ? 'disabled' : ''">
        <div class="step-header d-none d-md-block">
            <div class="svg-icon"
                 :style="'mask: url(/img/icons/house.svg); -webkit-mask-image: url(/img/icons/house.svg);'"></div>
            {{ $t('titles.property_type') }}&nbsp;*
            <i v-if="this.$parent.edit">Pro změnu tohoto parametru vytvořte nový odhad</i>
        </div>
        <div class="row">
            <div v-if="showSelect" class="col-12">
                <div class="form-group w-100">
                    <label for="property_type" class="required font-weight-medium d-md-none">{{ $t('titles.property_type') }}</label>
                    <select class="custom-select border-radius-20 " id="property_type" name="property_type"
                            @change="setType($event.target.value)"
                            v-model="property"
                    >
                        <option
                            :value="'flat'"
                        >
                            {{ $t('property_type.flat') }}
                        </option>
                        <option
                            :value="'house'"
                        >
                            {{ $t('property_type.family_house') }}
                        </option>
                        <option
                            :value="'hut'"
                        >
                            {{ $t('property_type.hut') }}
                        </option>
                        <option
                            :value="'cottage'"
                        >
                            {{ $t('property_type.cottage') }}
                        </option>
                        <option
                            :value="'land'"
                        >
                            {{ $t('property_type.land') }}
                        </option>
                    </select>
                </div>
            </div>
            <div v-else class="col-12 ">
                <div id="flat" class="radio-check" v-on:click="setType('flat')">
                    <div class="image">
                        <b class="d-block">{{ $t('property_type.flat') }}</b>
                        <div class="svg-icon"
                             :style="'mask: url('+ assetsUrl + '/flat.svg); -webkit-mask-image: url('+ assetsUrl + '/flat.svg);'"></div>
                        <div class="d-flex align-items-center justify-content-center">
                            <span class="btn btn-outline-secondary" v-if="property !== 'flat'">{{ $t('buttons.choose') }}</span>
                            <span class="btn btn-primary" v-else><i class="fas fa-check"></i>&nbsp;{{ $t('buttons.chosen') }}</span>
                        </div>
                    </div>
                    <input type="radio" name="property_type" value="flat" v-model="property">
                </div>

                <div id="house" class="radio-check" v-on:click="setType('house')">
                    <div class="image">
                        <b class="d-block">{{ $t('property_type.family_house') }}</b>
                        <div class="svg-icon"
                             :style="'mask: url('+ assetsUrl + '/house.svg); -webkit-mask-image: url('+ assetsUrl + '/house.svg);'"></div>
                        <div class="d-flex align-items-center justify-content-center">
                            <span class="btn btn-outline-secondary" v-if="property !== 'house'">{{ $t('buttons.choose') }}</span>
                            <span class="btn btn-primary" v-else><i class="fas fa-check"></i>&nbsp;{{ $t('buttons.chosen') }}</span>
                        </div>
                    </div>
                    <input type="radio" name="property_type" value="house" v-model="property">
                </div>

                <div id="hut" class="radio-check" v-on:click="setType('hut')">
                    <div class="image">
                        <b class="d-block">{{ $t('property_type.hut') }}</b>
                        <div class="svg-icon"
                             :style="'mask: url('+ assetsUrl + '/hut.svg); -webkit-mask-image: url('+ assetsUrl + '/hut.svg);'"></div>
                        <div class="d-flex align-items-center justify-content-center">
                            <span class="btn btn-outline-secondary" v-if="property !== 'hut'">{{ $t('buttons.choose') }}</span>
                            <span class="btn btn-primary" v-else><i class="fas fa-check"></i>&nbsp;{{ $t('buttons.chosen') }}</span>
                        </div>
                    </div>
                    <input type="radio" name="property_type" value="hut" v-model="property">
                </div>
                <div id="cottage" class="radio-check" v-on:click="setType('cottage')">
                    <div class="image">
                        <b class="d-block">{{ $t('property_type.cottage') }}</b>
                        <div class="svg-icon"
                             :style="'mask: url('+ assetsUrl + '/cottage.svg); -webkit-mask-image: url('+ assetsUrl + '/cottage.svg);'"></div>
                        <div class="d-flex align-items-center justify-content-center">
                            <span class="btn btn-outline-secondary" v-if="property !== 'cottage'">{{ $t('buttons.choose') }}</span>
                            <span class="btn btn-primary" v-else><i class="fas fa-check"></i>&nbsp;{{ $t('buttons.chosen') }}</span>
                        </div>
                    </div>
                    <input type="radio" name="property_type" value="cottage" v-model="property">
                </div>
                <div id="land" class="radio-check" v-on:click="setType('land')">
                    <div class="image">
                        <b class="d-block">{{ $t('property_type.land') }}</b>
                        <div class="svg-icon"
                             :style="'mask: url('+ assetsUrl + '/land.svg); -webkit-mask-image: url('+ assetsUrl + '/land.svg);'"></div>
                        <div class="d-flex align-items-center justify-content-center">
                            <span class="btn btn-outline-secondary" v-if="property !== 'land'">{{ $t('buttons.choose') }}</span>
                            <span class="btn btn-primary" v-else><i class="fas fa-check"></i>&nbsp;{{ $t('buttons.chosen') }}</span>
                        </div>
                    </div>
                    <input type="radio" name="property_type" value="land" v-model="property">
                </div>
            </div>
        </div>

        <input type="hidden" name="house_type" value="hut" v-if="property == 'hut'">
        <input type="hidden" name="house_type" value="cottage" v-if="property == 'cottage'">
        <input type="hidden" name="house_type" value="family_house" v-if="property == 'house'">
    </div>
</template>

<script>
export default {
    name: "Type",

    props: ['assetsUrl'],

    data: function () {
        return {
            property: null,
            showSelect: false,
        }
    },

    mounted: function () {
        if (!this.$parent.edit) {
            $('#step-type .radio-check').on('click', function () {
                $('#step-type .radio-check').removeClass('active');
                $(this).addClass('active');
                $(this).find('input').prop('checked', true);
            });
        }

        let type = 'flat';
        this.setType(type, true);
        if (this.$parent.oldData.property_type) {
            this.setType(this.$parent.oldData.property_type, true);
            type = this.$parent.oldData.property_type;
        }
        $('#step-type .radio-check input[value="' + type + '"]').prop('checked', true);

        //  show select to max-width: 1200px
        this.showSelectToMaxWidth(1200);

    },

    computed: {
        required: function () {
            return this.property != null;
        }
    },

    methods: {
        getType: function () {
            return $('#step-type .radio-check input:checked').val();
        },

        setType: function (type, force = false) {
            if (!this.$parent.edit || force) {
                $('#step-type .radio-check').removeClass('active');
                $('#' + type).addClass('active');
                this.property = type;
                this.$parent.setType(type);
            }
        },
    }
}
</script>

<style scoped>
input[type="radio"] {
    display: none;
}

.radio-check {
    cursor: pointer;
}
</style>
